// Default Libraries
import { createActions, asyncAction } from '../helpers/redux';
import { push } from 'react-router-redux';
import { schema, normalize } from 'normalizr';
import union from 'lodash/union';

export const relationshipSchema = new schema.Entity('relationships', {
  type: relationshipTypeSchema,
  producer: elementSchema,
  consumer: elementSchema,
  tags: [tags],
});
const relationshipTypeSchema = new schema.Entity('types');
const elementSchema = new schema.Entity('elements');
const tags = new schema.Entity('tags');

// relationshipSchema.define({
//   type: relationshipTypeSchema,
//   producer: elementSchema,
//   consumer: elementSchema,
//   tags: [tags]
// });

export const RelationshipActions = createActions({
  @asyncAction()
  async getRelationship(relationshipId, options) {
    return ({ client }) => {
      return client
        .get(`/relationship/${relationshipId}`, {
          qs: {
            fields: union(['type'], options.fields).join(','),
          },
        })
        .then(response => {
          return normalize(response, relationshipSchema);
        });
    };
  },

  @asyncAction()
  async getRelationships(projectId, viewId, producer, consumer, refIds) {
    return ({ client }) => {
      return client
        .post(`/relationship/getthis`, {
          body: {
            projectId,
            viewId,
            producer,
            refIds,
            consumer,
          },
        })
        .then(function(response) {
          return normalize(response, [relationshipSchema]);
        });
    };
  },

  @asyncAction()
  async updateProperty(relationshipId, options) {
    return ({ client }) => {
      return client
        .patch(`/relationships/${relationshipId}/props`, {
          body: {
            props: options.props,
          },
        })
        .then(response => {
          return {
            props: response,
            relationshipId,
          };
        });
    };
  },

  @asyncAction()
  async createCustomProperty(relationshipId, options) {
    return ({ client }) => {
      return client
        .post(`/relationships/${relationshipId}`, {
          body: {
            customProps: options.customProps,
          },
        })
        .then(response => {
          if (options.success) options.success();
          return {
            custom_props: response,
            relationshipId,
          };
        });
    };
  },

  @asyncAction()
  async updateCustomProperty(relationshipId, options) {
    return ({ client }) => {
      return client
        .patch(`/relationships/${relationshipId}/customprops`, {
          body: {
            customProps: options.customProps,
          },
        })
        .then(response => {
          if (options.success) options.success();
          return {
            custom_props: response,
            relationshipId,
          };
        });
    };
  },

  @asyncAction()
  async tearOrUntearRelationshipsBulk(relationshipIds, projectId, tear) {
    return ({ client }) => {
      return client
        .patch(`/relationships/bulk`, {
          body: {
            relationshipIds,
            projectId,
            props: {
              Assumption: {
                hidden: tear,
                description: '',
              },
            },
          },
        })
        .then(response => {
          return normalize(response, [relationshipSchema]);
        });
    };
  },

  @asyncAction()
  async createRelationships(relationships, currentProjectId) {
    return async ({ client, getState }) => {
      const relationshipsToAdd = [];

      relationships.forEach((rel, key) => {
        const possibleRelationships = getState().elementsRelationships.getIn([
          'elementsRelationships',
          rel.consumer,
          'consumesFrom',
        ]);

        if (!possibleRelationships || possibleRelationships.size === 0) {
          relationshipsToAdd.push(rel);
        } else {
          let flag = false;

          possibleRelationships.forEach(possibleRel => {
            const relCheck = getState().relationships.getIn([
              'relationships',
              possibleRel,
            ]);

            if (
              relCheck &&
              relCheck.get('producer') === rel.producer &&
              relCheck.get('type_id') === rel.type_id
            ) {
              flag = true;
            }
          });

          if (!flag) {
            relationshipsToAdd.push(rel);
          }
        }
      });

      if (relationshipsToAdd.length > 0) {
        return client
          .post(`/relationships`, {
            body: relationshipsToAdd,
          })
          .then(newRelationship => {
            return normalize(newRelationship, [relationshipSchema]);
          });
      }
    };
  },

  @asyncAction()
  async patchRelationships(data, project_id) {
    return async ({ client, getState }) => {
      return client
        .patch(`/relationships`, {
          body: {
            project_id,
            data,
          },
        })
        .then(newRelationship => {
          return normalize(newRelationship, [relationshipSchema]);
        });
    };
  },

  @asyncAction()
  async deleteRelationships(relationships, currentProjectId, dsm) {
    return async ({ client, getState, Checkit }) => {
      const relationshipIdsToDelete = [];
      const relationshipsCopy = relationships;

      if (dsm) {
        relationships.forEach((rel, key) => {
          const possibleRelationships = getState().elementsRelationships.getIn([
            'elementsRelationships',
            rel.consumer,
            'consumesFrom',
          ]);

          if (possibleRelationships) {
            possibleRelationships.forEach(possibleRel => {
              const relCheck = getState().relationships.getIn([
                'relationships',
                possibleRel,
              ]);

              if (relCheck.get('producer') === rel.producer) {
                const relId = relCheck.get('id');
                relationshipsCopy[key].relId = relId;
                relationshipIdsToDelete.push(relId);
              }
            });
          }
        });
      } else {
        if (relationshipIdsToDelete.length === 0) {
          relationships.forEach(rel => {
            const relId = rel.id;
            relationshipIdsToDelete.push(relId);
          });
        }
      }

      return client
        .post('/relationships/delete', {
          body: {
            relationshipIdsToDelete,
            currentProjectId,
          },
        })
        .then(() => {
          return {
            relationships: relationshipsCopy,
            relationshipIdsToDelete,
          };
        });
    };
  },

  @asyncAction()
  async deleteRelationship(relationship, deleteTab) {
    return ({ dispatch, client, getState, Checkit }) => {
      return client
        .delete(`/relationships/${relationship.get('id')}`)
        .then(response => {
          dispatch(push(`/project/${relationship.get('project_id')}/default`));
          return {
            relationship: relationship.toJSON(),
            closeTab: deleteTab,
          };
        });
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/relationship.js